import script from "./ShareLinkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareLinkCard.vue?vue&type=script&setup=true&lang=js"

import "./ShareLinkCard.vue?vue&type=style&index=0&id=7215ec06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7215ec06"]])

export default __exports__